// extracted by mini-css-extract-plugin
export default {"wrapper":"clbIyAtPQ0fRZZW","error":"TEnYk8JytA7865e","attachment-icon":"IOQA6keaY07qXXu"};